import { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gql';
import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import type { PaymentType } from 'src/app/shared/utils/payments';

import { useMembershipModalState } from '../../modalContext';
import type { ModalCallbackProps } from '../../shared/types';
import { useAmountConverter } from '../useAmountConverter';

export function useOnTokenError({ onDecline }: ModalCallbackProps): (paymentType: PaymentType, err: Error) => void {
	const [{ amount }, { setGeneralErrorMessage, clearLoading }] = useMembershipModalState();
	const { translate } = useI18n();
	const track = useTracking();
	const { toAmountUsd } = useAmountConverter();

	return function onTokenError(_paymentType, err): void {
		clearLoading();
		if (err instanceof GQLResponsePerimeterXChallengeError) {
			void track('post_promote_member_failure', {
				source_location: 'post_promote',
				errorMessage: 'Human verification required',
				errorType: 'RequestBlocked',
				amount: toAmountUsd(amount),
				local_amount: amount,
			});
			onDecline();
		} else {
			void track('post_promote_member_failure', {
				errorMessage: err.message || 'Unknown error',
				amount: toAmountUsd(amount),
				local_amount: amount,
			});
		}
		setGeneralErrorMessage(translate('corgi.co.promote.generic_payment_error'));
	};
}
